<script>
export default {
  props: {
    color: {
      type: String,
      default: '#cccccc'
    },
    label: {
      type: String,
      default: ''
    },
    tooltip: {
      type: String,
      default: ''
    }
  }
}
</script>

<template>
<v-tooltip top>
  <template #activator="{ on }">
    <div v-on="on" class="traffic-light">
      <div class="light-bulb" :style="{ backgroundColor: color }" />
      <div class="light-label">{{ label }}</div>
    </div>
  </template>

  {{ tooltip }}
</v-tooltip>
</template>

<style lang="scss" scoped>
.traffic-light {
  align-items: center;
  display: flex;
  gap: 0.25rem;

  .light-bulb {
    background-color: inherit;
    border-radius: 50%;
    height: 1.5rem;
    width: 1.5rem;
  }

  .light-label {
    font-size: 1.25rem;
  }
}
</style>
